
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-mermaid.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-plugin-mermaid-demo-basic","docs-x-markdown-plugin-mermaid-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-mermaid.en-US.md?type=demo')
};